/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type StorefrontSocial_viewer$ref = any;
export type StorefrontHead_viewer$ref = any;
export type StorefrontHead_viewer = {
    readonly " $fragmentRefs": StorefrontSocial_viewer$ref;
    readonly " $refType": StorefrontHead_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontHead_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "StorefrontSocial_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '2d05f21453267818c21dab5d8922a2a2';
export default node;
